import { IconType } from "react-icons";
import { CgUnavailable } from "react-icons/cg";
import { FaNetworkWired } from "react-icons/fa";
import { GiProgression } from "react-icons/gi";
import { IoMdContacts } from "react-icons/io";
import {
  MdDashboard,
  MdOutlineWork,
  MdOutlineMonetizationOn,
  MdShowChart,
} from "react-icons/md";
import { TbBrandBooking } from "react-icons/tb";
import { GrTransaction } from "react-icons/gr";
import { IoCalendarOutline, IoPeopleOutline } from "react-icons/io5";
import { HiOutlineOfficeBuilding, HiOutlineUserCircle } from "react-icons/hi";
import { IoLogoWhatsapp } from "react-icons/io";
import { CiGrid42 } from "react-icons/ci";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { AiOutlineHeatMap, AiOutlineInsertRowAbove } from "react-icons/ai";

function DynamicIcon(props: any) {
  type IconName =
    | "MdDashboard"
    | "TbBrandBooking"
    | "CgUnavailable"
    | "GiProgression"
    | "MdOutlineWork"
    | "FaNetworkWired"
    | "IoPeopleOutline"
    | "GrTransaction"
    | "HiOutlineOfficeBuilding"
    | "IoCalendarOutline"
    | "LiaFileInvoiceDollarSolid"
    | "CiGrid42"
    | "AiOutlineInsertRowAbove"
    | "HiOutlineUserCircle"
    | "AiOutlineHeatMap"
    | "IoMdContacts"
    | "IoLogoWhatsapp"
    | "MdOutlineMonetizationOn"
    | "MdShowChart";

  interface IconProps {
    iconName: IconName;
    size?: number;
    color?: string;
  }

  function Icon({ iconName, size = 25, color = "#0a2f35" }: IconProps) {
    const icons: Record<IconName, IconType> = {
      MdDashboard: MdDashboard,
      TbBrandBooking: TbBrandBooking,
      CgUnavailable: CgUnavailable,
      GiProgression: GiProgression,
      MdOutlineWork: MdOutlineWork,
      FaNetworkWired: FaNetworkWired,
      IoMdContacts: IoMdContacts,
      IoPeopleOutline: IoPeopleOutline,
      HiOutlineOfficeBuilding: HiOutlineOfficeBuilding,
      IoCalendarOutline: IoCalendarOutline,
      LiaFileInvoiceDollarSolid: LiaFileInvoiceDollarSolid,
      GrTransaction: GrTransaction,
      CiGrid42: CiGrid42,
      AiOutlineInsertRowAbove: AiOutlineInsertRowAbove,
      HiOutlineUserCircle: HiOutlineUserCircle,
      AiOutlineHeatMap: AiOutlineHeatMap,
      IoLogoWhatsapp: IoLogoWhatsapp,
      MdOutlineMonetizationOn: MdOutlineMonetizationOn,
      MdShowChart: MdShowChart,
    };

    if (!icons.hasOwnProperty(iconName)) {
      console.warn(
        `Icon '${iconName}' not found. Rendering default icon instead.`
      );
      iconName = "CgUnavailable";
    }

    const IconComponent = icons[iconName];

    return <IconComponent size={size} />;
  }

  return <Icon iconName={props.icon} size={props.size} color={props.color} />;
}

export default DynamicIcon;
